import React, { Fragment } from 'react';
import humaniseDuration from 'humanise-duration';
import { getEnvironmentShort, getMeanRuleDownloads, getMedianRuleDownloads } from "../../../util/helpers";
import RemoteConfig from '../components/RemoteConfig';

const AnalyticsSummary = ({
    testInstance,
    scenario,
    triggersCount,
    toggleSummary,
    isShowingSummary,
    showRemoteConfig,
    displayRemoteConfigDetails,
}) => {
    let startTime = new Date(testInstance.startTime);
    let endTime = new Date(testInstance.endTime);

    let duration = endTime - startTime;
    let durationDisplay = humaniseDuration(duration);

    let overviewStartTimeDisplay, overviewEndTimeDisplay;

    if (
        testInstance !== '' &&
        typeof testInstance.startTime !== 'undefined' &&
        typeof testInstance.endTime !== 'undefined'
    ) {
        overviewStartTimeDisplay = new Date(testInstance.startTime).toLocaleString('en-us');
        overviewEndTimeDisplay = new Date(testInstance.endTime).toLocaleString('en-us');
        durationDisplay = humaniseDuration(new Date(testInstance.endTime) - new Date(testInstance.startTime));
    }

    let commentsBox = '';
    if (testInstance !== '' && testInstance.comments.length) {
        const { comments } = testInstance;
        const commentsWithLineBreaks = comments.split('\n').map(item => <div key={item}>{item}</div>);
        commentsBox = (
            <div className="analytics-summary-comments">
                <label>Comments</label>
                <div className="analytics-summary-comments--box">{commentsWithLineBreaks}</div>
            </div>
        );
    }

    return (
        <div className="test-instance-overview-details block">
            <div className="block-overview-heading selectable">
                {testInstance.name}
                <button onClick={toggleSummary} className="btn btn-default analytics-summary-toggle-btn">
                    {isShowingSummary ? 'Hide' : 'Show Summary'}
                </button>
            </div>
            {isShowingSummary && (
                <Fragment>
                    <div className="analytics-summary-wrapper">
                        <div className="analytics-summary-fields">
                            <label>Scenario</label>
                            <div className="user-select-all">
                                {scenario.name === '' ? (
                                    <div className="not-specified">Not specified</div>
                                ) : (
                                    scenario.name
                                )}
                            </div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>SDK Version</label>
                            <div className="user-select-all">
                                {testInstance === '' ? (
                                    ''
                                ) : testInstance.sdkVersion === '' ? (
                                    <div className="not-specified">Not specified</div>
                                ) : (
                                    testInstance.sdkVersion
                                )}
                            </div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>Triggers</label>
                            <div className="user-select-all">{triggersCount}</div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>Environment</label>
                            <div className="user-select-all">
                                {' '}
                                {scenario.environment === '' ? (
                                    <div className="not-specified">Not specified</div>
                                ) : (
                                    getEnvironmentShort(scenario.environment)
                                )}
                            </div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>Mode</label>
                            <div className="user-select-all">
                                {' '}
                                {testInstance === '' ? (
                                    ''
                                ) : testInstance.mode === '' ? (
                                    <div className="not-specified">Not specified</div>
                                ) : (
                                    testInstance.mode
                                )}
                            </div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>Number of Zones</label>
                            <div className="user-select-all">{scenario.zones && scenario.zones.length}</div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>Project Id</label>
                            <div className="user-select-all">
                                {scenario.projectId === '' ? (
                                    <div className="not-specified">Not specified</div>
                                ) : (
                                    scenario.projectId
                                )}
                            </div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>Api Key</label>
                            <div className="user-select-all">
                                {scenario.apiKey === '' ? (
                                    <div className="not-specified">Not specified</div>
                                ) : (
                                    scenario.apiKey
                                )}
                            </div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>Start Time</label>
                            <div className="user-select-all">{overviewStartTimeDisplay}</div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>End Time</label>
                            <div className="user-select-all"> {overviewEndTimeDisplay}</div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>Duration</label>
                            <div className="user-select-all"> {durationDisplay}</div>
                        </div>
                        <div className="analytics-summary-fields">
                            <a className="pointer-cursor remote-config" onClick={displayRemoteConfigDetails}>
                                Show Remote Config Details
                            </a>

                            {showRemoteConfig ? (
                                <RemoteConfig
                                    handleHideModal={displayRemoteConfigDetails}
                                    configurationParameters={testInstance.configurationParameters}
                                />
                            ) : null}
                        </div>
                        <div className="analytics-summary-fields">
                            <label>Mean rule downloads</label>
                            <div className="user-select-all"> {typeof testInstance == "object"?getMeanRuleDownloads(testInstance):"N/A"}</div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>Median rule downloads</label>
                            <div className="user-select-all"> {typeof testInstance == "object"?getMedianRuleDownloads(testInstance):"N/A"}</div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>iOS BG Loc indicator</label>
                            <div className="user-select-all">{testInstance.enableBackgroundLocationIndicator ? "true" : "false"}</div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>Android BG Mode</label>
                            <div className="user-select-all">{testInstance.enableBGMode ? "true" : "false"}</div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>Device DPH</label>
                            <div className="user-select-all">{!isNaN(scenario.deviceDPH) ? scenario.deviceDPH + "%" : "N/A"}</div>
                        </div>
                        <div className="analytics-summary-fields">
                            <label>Type</label>
                            <div className="user-select-all">{scenario.type}</div>
                        </div>
                    </div>
                    {commentsBox}
                </Fragment>
            )}
        </div>
    );
};

export default AnalyticsSummary;
